import styles from "@/styles/checkout-layout.module.scss"
import { useEffect } from "react"
import Link from 'next/link'
import { Image } from "antd"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"
import { loadForter } from "@/utils/forter";

import ComodoSecureSvg from "@/svgs/comodo-secure.svg"
import NortonSvg from "@/svgs/norton.svg"

import loginApi from '@/service/modules/loginApi';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import { useRouter } from 'next/router';
import UvpBanner from "./UvpBanner"
import { abTestCalculate } from "@/utils/ABtest"
import { setCookie } from "@/utils/cookie"
const apiDomain = publicRuntimeConfig.apiDomain;
interface LayoutProps {
  children: React.ReactNode;
}

export default function DefaultLayout(props: LayoutProps) {
  const currentYear = new Date().getFullYear(); // 获取当前年份

  // 请求me接口，这里需要登录（另外可以续命session）
  const renewalLoginStatus = async () => {
    try {
      const res = await loginApi.me()
      console.log(res, ' == user info');
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    function handleWindowLoad() {
      setTimeout(() => {
        renewalLoginStatus();
      }, 2000);

      loadMatomo()
      loadForter();
      // dataLayer数据需要先异步等待加载完成再执行，设置先不加载的白名单URL
      const whitelistPattern = /^(\/view-cart|\/payment-result|\/checkout\/b-pay|\/online)/;
      if (!whitelistPattern.test(window.location.pathname)) {
        loadGtm(); // 如果不匹配，则加载 GTM
      }
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const router = useRouter()

  useEffect(() => {
    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''

    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }

    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }

    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if (currentDomain == 'www.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
    }

  }, [router.query])

   useEffect(() => {
    // 加载AB测试逻辑
    abTestCalculate("")
  }, [])

  return (
    <div className={styles['checkout-layout']}>
      <div className={styles['header-box']}>
        <div className={styles['header']}>
          <div className={styles['left']}>
            <Link
              href={`/`}
              legacyBehavior
            >
              <a rel="noopener noreferrer">
                <Image src={`${imageDomain}/logo.png`} width={425} preview={false} />
              </a>
            </Link>
          </div>
        </div>
      </div>

      <div className={styles['uvpBanner']}>
        <UvpBanner type="viewcart" />
      </div>

      <main className={styles['checkout-layout-container']}>
        {props.children}
      </main>

      <div className={styles['footer-box']}>
        Copyright &copy; 2007 - {currentYear} Best Deals Store. All Rights Reserved.
      </div>
    </div>
  )
}